import elyceumScreen from '../assets/e-lyceum-page/screen.png';
import talantScreen from '../assets/e-lyceum-page/talant.png';
import selfScreen from '../assets/e-lyceum-page/self.png';
import profScreen from '../assets/e-lyceum-page/prof.png';

const digitalDevelopmentsData = [
  {
    id: 'e-lyceum',
    title: 'Вебплатформа електронної реєстрації «Є-ліцей»',
    badge: 'Освітня цифрова екосистема',
    url: null,
    isOffline: true,
    statusNotice: 'Хостинг проєкту тимчасово призупинено',
    icon: 'GraduationCap',
    image: elyceumScreen,
    imageAlt: 'Головна сторінка вебплатформи «Є-ліцей»',
    gradient: 'from-blue-700 via-indigo-700 to-blue-900',
    summary: 'Full-stack вебплатформа для автоматизованої онлайн-подачі та опрацювання заяв до 10-х класів ліцеїв Дрогобицької міської територіальної громади.',
    description: `Я розробив full-stack вебплатформу «Є-ліцей» для електронної подачі та обробки заяв до 10-х класів ліцеїв. Проєкт створено для оптимізації освітніх процесів громади: він допомагає учням та їхнім батькам зручно й швидко подавати заявки онлайн, а закладам освіти та управлінню освіти — оперативно їх переглядати, опрацьовувати, змінювати статуси та аналізувати зведену інформацію.

У цьому проєкті я реалізував повний цикл електронного документообігу: захищену реєстрацію та авторизацію користувачів, багаторольовий доступ (учень, школа, управління освіти, адміністратор) з окремими персоналізованими кабінетами, створення та моніторинг заяв, фіксацію історії зміни статусів, статистичний модуль поданих заяв по закладах освіти громади, а також роботу з базою даних PostgreSQL через Prisma ORM.`,
    features: [
      'Зручне онлайн-подання та електронна реєстрація заяв до 10-х класів',
      'Багаторольовий доступ: учень, школа, управління освіти, адміністратор',
      'Окремі персоналізовані кабінети для кожної категорії користувачів',
      'Оперативне створення, перегляд, валідація та зміна статусів заяв',
      'Повна історія та прозорий трекінг зміни статусів кожної заявки',
      'Аналітична статистика ��оданих заяв у розрізі ліцеїв громади',
      'Надійна аутентифікація (NextAuth.js) та захист облікових даних',
      'Повноцінна робота з базою даних PostgreSQL через Prisma ORM'
    ],
    tags: [
      'Next.js',
      'React',
      'JavaScript',
      'Tailwind CSS',
      'Prisma ORM',
      'PostgreSQL',
      'NextAuth.js',
      'Full-stack розробка'
    ]
  },
  {
    id: 'talant-hub',
    title: 'Інформаційно-освітній портал «Дрогобич Талант Хаб»',
    badge: 'Освітній міський вебпортал',
    url: 'https://talant-hub.osvita-drohobych.gov.ua/',
    icon: 'Compass',
    image: talantScreen,
    imageAlt: 'Інтерфейс інформаційно-освітнього порталу «Дрогобич Талант Хаб»',
    gradient: 'from-blue-600 to-cyan-500',
    summary: 'Єдиний міський цифровий простір для презентації позашкільної освіти Дрогобича, профорієнтації та пошуку гуртків і секцій.',
    description: `Я розробив платформу «Дрогобич Талант Хаб» як єдиний міський цифровий простір для популяризації позашкільної освіти міста Дрогобича та розкриття потенціалу дітей і учнівської молоді.

Портал допомагає батькам та учням швидко орієнтуватися у гуртках, секціях і творчих об'єднаннях міста: знайомитися із закладами позашкільної освіти (Палац дитячої та юнацької творчості, Станція юних туристів, Будинок науково-технічної творчості, ДЮСШ тощо), їхніми керівниками, напрямами діяльності та контактами.

У проєкті також реалізовано інтерактивний модуль «Квест твого таланту» — профорієнтаційний тест із 20 запитань для визначення схильностей і обдарувань дитини, а також інтерактивну мапу розташування закладів позашкілля громади.`,
    features: [
      'Каталог закладів позашкільної освіти міста Дрогобича',
      '��нтерактивний профорієнтаційний «Квест твого таланту»',
      'Інтерактивна геолокаційна мапа закладів та гуртків',
      'Детальна інформація про гуртки, керівників та вікові категорії',
      'Зручний пошук і фільтрація освітніх напрямів'
    ],
    tags: ['React', 'Вебпортал', 'Позашкільна освіта', 'Інтерактивна карта', 'Профорієнтаційний квест']
  },
  {
    id: 'self-assessment',
    title: 'Вебзастосунок «Самооцінювання професійної діяльності педагога»',
    badge: 'Інтерактивний діагностичний сервіс',
    url: 'https://self-assessment-questionnaires.netlify.app/',
    icon: 'CheckSquare',
    image: selfScreen,
    imageAlt: 'Інтерфейс вебзастосунку «Самооцінювання професійної діяльності педагога»',
    gradient: 'from-emerald-600 to-teal-500',
    summary: 'Цифровий інструмент для самооцінювання професійних компетентностей, визначення зон росту та побудови траєкторії розвитку.',
    description: `Я створив цей інтерактивний вебзастосунок для підтримки педагогічних працівників у процесі самооцінювання власної професійної діяльності відповідно до сучасних стандартів та критеріїв оцінювання якості освіти.

Сервіс дозволяє вчителям зручно та об'єктивно проаналізувати рівень сформованості професійних компетентностей, зафіксувати власні сильні сторони та виявити актуальні зони для професійного зростання.

За результатами проходження опитувальника формується наочна діагностична картина, яка стає основою для планування індивідуальної освітньої траєкторії, самоосвіти, а також якісної підготовки до атестації чи сертифікації педагога.`,
    features: [
      'Структуровані анкети й опитувальники професійних компетентностей',
      'Миттєвий підрахунок та візуалізація результатів самооцінювання',
      'Визначення сильних сторін та зон професійного розвитку',
      'Допомога у плануванні індивідуального плану самоосвіти',
      'Адаптивний та інтуїтивно зрозумілий користувацький інтерфейс'
    ],
    tags: ['React / Vite', 'Вебзастосунок', 'Самооцінювання', 'Професійний розвиток', 'Діагностика компетентностей']
  },
  {
    id: 'prof-standart',
    title: 'Інтерактивний довідник «Професійний стандарт вчителя ЗЗСО»',
    badge: 'Цифровий нормативний довідник',
    url: 'https://prof-standart-teacher.netlify.app/',
    icon: 'BookOpenCheck',
    image: profScreen,
    imageAlt: 'Інтерфейс інтерактивного довідника «Професійний стандарт вчителя ЗЗСО»',
    gradient: 'from-indigo-600 to-purple-600',
    summary: 'Інтерактивний цифровий навігатор тр��довими функціями, компетентностями та кваліфікаційними категоріями вчителя ЗЗСО.',
    description: `Я розробив цей інтерактивний вебресурс для зручної структуризації, швидкої навігації та детального опрацювання положень Професійного стандарту вчителя закладу загальної середньої освіти (затвердженого МОН України).

Вебзастосунок трансформує об'ємний нормативний документ у зручний цифровий формат: дає змогу швидко переглядати трудові функції, професійні компетентності, знання, уміння та навички, диференційовані за кваліфікаційними категоріями (спеціаліст, ІІ категорія, І категорія, вища категорія).

Ресурс слугує надійним помічником для вчителів під час підготовки до атестації та сертифікації, а також для керівників закладів освіти, методистів та атестаційних комісій.`,
    features: [
      'Повна цифрова версія Професійного стандарту вчителя ЗЗСО',
      'Структурування за трудовими функціями та компетентностями',
      'Зручне порівняння вимог для різних кваліфікаційних категорій',
      'Швидкий пошук знань, умінь, навичок та критеріїв оцінювання',
      'Оптимізований доступ для педагогів, методистів та керівників шкіл'
    ],
    tags: ['Вебресурс', 'Професійний стандарт', 'Трудові функції', 'Кваліфікаційні категорії', 'Нормативна база']
  }
];

export default digitalDevelopmentsData;
